var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tsny-modal',{attrs:{"modal-id":_vm.modalId,"modal-title":'Leave Page?',"submit-button-text":'LEAVE',"submit-modal":_vm.leavePage}},[_c('p',{staticClass:"tsny_status-text"},[_vm._v("\n    "+_vm._s(_vm.modalText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }